<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <button-add :pathName="addAccountRouterName" :value="addBtnValue" v-if="permissionCodes.indexOf('001008001') !== -1"/>
      <input-search :placeholder="searchPlaceholder" @search="search" />
    </div>
    <table-main :tableHead="tableHead" :tableData="tableData" @deleteLine="deleteLine" @goToModifyPage="goToModifyPage" :deleteTipInfo="deleteTipInfo" :operationArr="operationArr" :total="total" :pageNum="pageNum" :pageSize="pageSize" @changePagination="changePagination" />
  </div>
</template>

<script>
import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
import ButtonAdd from '../../../components/Button/ButtonAdd'
import InputSearch from '../../../components/Input/InputSearch'
import TableMain from '../../../components/Table/TableMain'
import {api} from '../../api/role'
import {errorHandler} from '../../../utils/errorHandler'
import {nSuccess} from '../../../utils/notice'
import {bus} from "../../../utils/bus";

export default {
  components: {
    TableMain,
    InputSearch,
    ButtonAdd,
    Breadcrumb},
  name: 'role-management',
  data () {
    return {
      permissionCodes: '',
      breadcrumb: [{
        value: '资源中心',
        name: 'yq-information'
      }, {
        value: '角色管理'
      }],
      addAccountRouterName: 'role-add',
      addBtnValue: '新建角色',
      searchPlaceholder: '角色名',
      deleteTipInfo: '是否确认删除该角色？',
      tableHead: [{
        prop: 'name',
        label: '角色'
      }],
      tableData: [],
      total: 0,
      pageSize: 10,
      pageNum: 1,
      operationArr: ['modify', 'delete']
    }
  },
  created () {
    this.permissionCodes = bus.global.permissionCodes
    this.getPage()
  },
  methods: {
    getPage () {
      this.$axios.post(api.getPage, {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        searchKey: this.searchKey
      })
        .then(res => {
          if (res.data.retCode === 1) {
            this.total = res.data.data.total
            let data = res.data.data.list
            // data.map(v => {
            //   v.createTime = v.createTime.slice(0, 19)
            // })
            this.tableData = data
          }
        })
        .catch(errorHandler('获取角色列表失败'))
    },
    changePagination (data) {
      this.pageNum = data[0]
      this.pageSize = data[1]
      this.getPage()
    },
    search (v) {
      this.pageNum = 1
      this.searchKey = v
      this.getPage()
    },
    // 修改
    goToModifyPage (code) {
      this.$router.push({
        path: `/role_modify/${code}`
      })
    },
    // 删除
    deleteLine (code) {
      this.$axios.post(api.deleteByCodes, code)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess('删除成功')
            this.getPage()
          }
        })
        .catch(errorHandler('获取子账号列表失败'))
    }
  }
}
</script>

<style scoped>
  .search-line {
    display: flex;
    justify-content: space-between;
    margin: 20px 0;
  }
</style>



// WEBPACK FOOTER //
// src/view/ResourceCenter/RoleManagement/RoleManagement.vue